import { Section } from '../../../components/Section'
import { SliteAgentBento } from './SliteAgentBento'
import { SliteAgentFeatures } from './SliteAgentFeatures'
import { SliteAgentHero } from './SliteAgentHero'

export function SectionHomeSliteAgent({
  title,
  description,
  hideCta,
}: {
  title?: string
  description?: string
  hideCta?: boolean
} = {}) {
  return (
    <Section
      background="moon-dust-lighter"
      containerVerticalPadding={120}
      className="text-align-center"
    >
      <SliteAgentHero title={title} description={description} />
      <SliteAgentFeatures />
      <div style={{ marginTop: 100 }} />
      <SliteAgentBento hideCta={hideCta} />
    </Section>
  )
}
